<!--/////////////////////////////-->
<!-- <nav class="navbar navbar-expand-lg fixed-top custom-nav" [ngClass]="{ 'scrolled': isScrolled }">
  <div class="container">
    <a class="navbar-brand d-flex align-items-center fs-18px fontWeight600" href="#">
      <img src="assets/logo/logo_.png" alt="Centrix" class="logo me-2">
      Centrix Perú
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item"><a class="nav-link fs-14px" href="#">Soluciones</a></li>
        <li class="nav-item"><a class="nav-link fs-14px" (click)="price()">Planes</a></li>
        <li class="nav-item"><a class="nav-link fs-14px" (click)="contact()">Contacto</a></li>
      </ul>

      <div class="d-flex align-items-center">
        <div class="nav-item ms-lg-3">
          <button class="btn-outline btn-sm d-flex align-items-center gap-2 py-2 px-3" (click)="ingresar()">Ingresar</button>
        </div>
        <div class="nav-item ms-lg-3">
          <button class="btn btn-sm d-flex align-items-center gap-2 py-2 px-3">Empieza gratis</button>
        </div>
      </div>
    </div>
  </div>
</nav> -->

<!-- <nav class="navbar navbar-expand-lg navbar-light bg-white fixed-top custom-nav" [ngClass]="{ 'scrolled': isScrolled }">
  <div class="container">
    <a class="navbar-brand fw-bold d-flex align-items-center" href="#">
      <div class="logo-dot me-2"></div> Centrix
    </a>
    <div class="ms-auto d-flex align-items-center gap-3">
      <span class="d-none d-md-block">Inicio</span>
      <span class="d-none d-md-block">Funcionalidades</span>
      <button class="btn btn-teal-outline">Prueba Gratis</button>
    </div>
  </div>
</nav> -->

<!-- <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top custom-nav" [ngClass]="{ 'scrolled': isScrolled }">
  <div class="container">
    <a class="navbar-brand fw-bold" href="#">CENTRIX <span class="text-success">Ventas</span></a>
    <div class="d-none d-md-block">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item"><span class="nav-link">Inicio</span></li>
        <li class="nav-item"><span class="nav-link">Funcionalidades</span></li>
        <li class="nav-item"><span class="nav-link">Precios</span></li>
        <li class="nav-item ms-lg-3 align-content-center">
          <button class="btn btn-success btn-sm rounded-pill px-3">Solicitar Demo</button>
        </li>
      </ul>
    </div>
  </div>
</nav> -->

<!-- <header class="header sticky-top">
  <div class="container d-flex justify-content-between align-items-center">
    <div class="logo">
      <img src="assets/logo/logoCentrix.png" alt="Centrix Peru" (click)="scrollTo('home1')">
    </div>
    <nav class="d-none d-md-flex gap-4 align-items-center">
      <a (click)="scrollTo('precios')" class="nav-link">Precios</a>
      <button class="btn-demo" (click)="solicitarDemo()">Solicitar Demo</button>
    </nav>
  </div>
</header> -->

<header [class.scrolled]="isScrolled()" class="fixed-top transition-all">
  <div class="containerHeader px-0">
    <div class="row px-0 mx-0 align-items-center">
      <div class="col-6 col-md-3">
        <div class="d-flex align-items-center gap-2">
          <div class="logo" (click)="inicio()">
            <img src="assets/logo/logoCentrix.png" alt="Centrix Peru">
          </div>
        </div>
      </div>
      <div class="col-md-6 d-none d-md-flex justify-content-center ms-auto d-flex align-items-center gap-4">
        <span class="d-none d-md-block spanLink" (click)="inicio()">Inicio</span>
        <span class="d-none d-md-block spanLink" (click)="servicios()">Servicios</span>
        <span class="d-none d-md-block spanLink" (click)="contacto()">Contacto</span>
      </div>
      <div class="col-6 col-md-3 text-end">
        <button class="btn btn-cotizar" (click)="cotizar()">Cotizar</button>
      </div>
    </div>
  </div>
</header>

<!-- <header [class.scrolled]="isScrolled()" class="fixed-top transition-all">
  <div class="container">
    <div class="row align-items-center py-3">
      <div class="col-6 col-md-3">
        <div class="logo">
          <img src="assets/logo/logoCentrix.png" alt="Centrix Peru">
        </div>
      </div>
      
      <nav class="col-md-6 d-none d-md-flex justify-content-center gap-4">
        @for (link of navLinks; track link.label) {
          <a [href]="link.href" class="nav-item">{{ link.label }}</a>
        }
      </nav>

      <div class="col-6 col-md-3 text-end">
        <button class="btn-cotizar d-none d-md-inline-block">Cotizar</button>
        <button class="d-md-none btn-menu" (click)="toggleMenu()">☰</button>
      </div>
    </div>
  </div>

  @if (menuOpen()) {
    <div class="mobile-nav d-md-none animate__animated animate__fadeIn">
      @for (link of navLinks; track link.label) {
        <a [href]="link.href" (click)="toggleMenu()">{{ link.label }}</a>
      }
      <button class="btn-cotizar w-100 mt-3">Cotizar</button>
    </div>
  }
</header> -->


